import React, {createContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import FlagProvider, {UnleashClient} from '@unleash/proxy-client-react';
import {UNLEASH_CONFIG} from '../../constants';

const client = new UnleashClient(UNLEASH_CONFIG);

const Context = createContext({});

export default Context;

export const UnleashProvider = ({children}) => {
  useEffect(() => {
    const instantiateUnleashClient = async () => {
      await client.start();
    };

    instantiateUnleashClient();
  }, []);

  return (
    <FlagProvider
      config={UNLEASH_CONFIG}
      startClient={false}
      unleashClient={client}>
      {children}
    </FlagProvider>
  );
};

UnleashProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
